// Bibliotecas externas
import React from 'react'

import DashboardIcon from '@material-ui/icons/DashboardRounded'
import LogoutIcon from '@material-ui/icons/ExitToAppRounded'
import ArquivosIvon from '@material-ui/icons/InsertDriveFile'
import CotacoesIcon from '@material-ui/icons/LocalAtm'
import FaturamentoIcon from '@material-ui/icons/ReceiptRounded'
import ConfiguracoesIcon from '@material-ui/icons/SettingsRounded'
import PainelEnergiaIcon from '@material-ui/icons/ViewList'
import AgentesIcon from 'mdi-material-ui/AccountBoxMultiple'
import { AlphaCBox as CurtoPrazoIcon } from 'mdi-material-ui'
import { AlphaLBox as LongoPrazoIcon } from 'mdi-material-ui'
import PedagioIcon from 'mdi-material-ui/BoomGate'
import FechamentosIcon from 'mdi-material-ui/PlaylistCheck'
import ContratosIcon from 'mdi-material-ui/TextBoxMultipleOutline'
import AssignmentIcon from '@material-ui/icons/Assignment';
import MedicoesIcon from 'mdi-material-ui/Counter'
import RelatorioIcon from '@material-ui/icons/Assessment'
import PerfilIcon from '@material-ui/icons/AccountCircleRounded'
import { AlphaPBox as PldIcon } from 'mdi-material-ui'
import TimelineIcon from '@material-ui/icons//Timeline'
import ConsolidadoIcon from '@material-ui/icons/ChromeReaderMode'
import EcoIcon from '@material-ui/icons/Eco'
import ReceiptIcon from '@material-ui/icons/Receipt'
import OfflineBoltIcon from '@material-ui/icons/OfflineBolt'
import SettingsInputAntennaIcon from '@material-ui/icons/SettingsInputAntenna'
import QueryDinamicaIcon from '@material-ui/icons/SearchRounded'
import TicketIcon from '@material-ui/icons/ConfirmationNumber'

// Imports absolutos internos
import { MenuLinkEngecomp } from 'components/Agentes/Links/Engecomp'
import { MenuLinkFaturasThymos } from 'components/Agentes/Links/FaturasThymos'
import { MenuLinkNottus } from 'components/Agentes/Links/NottusMeteorologia'
import { QUERY_DINAMICA_ALLOWED_EMAILS } from 'components/QueryDinamica/utils'
const eGridThymos = process.env.REACT_APP_COMPANY_NAME == 'Thymos'
const eGridElectric = ['Electric', 'ACME', 'eGrid'].includes(
  process.env.REACT_APP_COMPANY_NAME
)
const eGridDemo = ['ACME', 'eGrid'].includes(process.env.REACT_APP_COMPANY_NAME)
const isCopasa = process.env.REACT_APP_COMPANY_NAME === 'Copasa'
// v1 de Chamados: só eGrid ou localhost, ainda não liberado para os demais white-labels
const eGridV1Chamados =
  window.location.hostname === 'localhost' ||
  eGridDemo

// OBS: Adicionar o campo test: true, indica que é uma opção exclusiva para usuários
// com a flag 'teste de feature' ativa

const getClientItems = user => {
  const clientItems = [
    {
      icon: <DashboardIcon />,
      text: 'Dashboard',
      path: '/app/dashboard',
      divider: true,
    },
    {
      icon: <PedagioIcon />,
      text: 'Faturas de uso do sistema',
      path: '/app/pedagio',
    },
    {
      icon: <RelatorioIcon />,
      text: 'Relatórios',
      path: '/app/relatorios',
    },
    {
      icon: <ConsolidadoIcon />,
      text: 'Relatórios consolidados',
      path: '/app/consolidados',
    },
    {
      icon: <ContratosIcon />,
      text: 'Contratos de Energia',
      path: '/app/contratos',
    },
    // {
    //   icon: <AssignmentIcon />,
    //   text: 'Contratos GD',
    //   path: '/app/contratos_gd',
    // },
    {
      icon: <PldIcon />,
      text: 'PLD',
      path: '/app/pld',
    },
    {
      icon: <TimelineIcon />,
      text: 'Projeções',
      path: '/app/projecoes',
    },
    {
      icon: <CotacoesIcon />,
      text: 'Cotações',
      path: '/app/cotacoes',
    },
    ...(eGridElectric
      ? [
          {
            icon: <EcoIcon />,
            text: 'Sustentabilidade',
            path: '/app/sustentabilidade',
            test: true,
          },
        ]
      : []),
    ...(eGridThymos
      ? [MenuLinkEngecomp, MenuLinkFaturasThymos, MenuLinkNottus]
      : []),
    ...(eGridDemo || eGridElectric
      ? [
          {
            text: 'Geração Distribuída',
            icon: <OfflineBoltIcon />,
            path: '/app/geracao_distribuida',
            gd: true,
          },
        ]
      : []),
    {
      icon: <ReceiptIcon />,
      text: 'Coleta de Faturas',
      path: '/app/coleta_faturas',
      coleta: true,
    },
    {
      icon: <SettingsInputAntennaIcon />,
      text: 'Sentinela',
      path: '/app/sentinela',
      sentinela: true,
    },
    {
      icon: <MedicoesIcon />,
      text: 'Medições',
      path: '/app/medicoes',
      divider: true,
    },
    {
      icon: <PerfilIcon />,
      text: 'Minha conta',
      path: '/app/conta/perfil',
    },
    {
      icon: <ArquivosIvon />,
      text: 'Arquivos',
      path: '/app/arquivos',
      arquivos: true,
    },
    ...(eGridV1Chamados
      ? [{ icon: <TicketIcon />, text: 'Meus chamados', path: '/app/tickets' }]
      : []),
    {
      icon: <LogoutIcon />,
      text: 'Sair',
      path: '/session/destroy',
      divider: true,
    },
  ]

  const isBRK =
    user?.perfis?.some(p => p?.sigla_ccee?.toUpperCase().includes('BRK')) ?? false

  if (isCopasa) {
    return [
      { icon: <DashboardIcon />, text: 'Dashboard', path: '/app/dashboard', divider: true },
      { icon: <PldIcon />, text: 'PLD', path: '/app/pld' },
      { icon: <ReceiptIcon />, text: 'Coleta de Faturas', path: '/app/coleta_faturas' },
      { icon: <MedicoesIcon />, text: 'Medições', path: '/app/medicoes', divider: true },
      { icon: <PerfilIcon />, text: 'Minha conta', path: '/app/conta/perfil' },
      { icon: <LogoutIcon />, text: 'Sair', path: '/session/destroy', divider: true },
    ]
  }

  if (eGridElectric && isBRK) {
    const gdBRK = user?.roles?.includes('gd') || false

    return [
      { icon: <DashboardIcon />, text: 'Dashboard', path: '/app/dashboard', divider: true },
      { icon: <ReceiptIcon />, text: 'Coleta de Faturas', path: '/app/coleta_faturas' },
      ...(gdBRK
        ? [
            {
              icon: <OfflineBoltIcon />,
              text: 'Geração Distribuída',
              path: '/app/geracao_distribuida',
            },
          ]
        : []),
      { icon: <PerfilIcon />, text: 'Minha conta', path: '/app/conta/perfil' },
      { icon: <LogoutIcon />, text: 'Sair', path: '/session/destroy', divider: true }
    ]
  }

  let finalItems = clientItems
  const coletaFaturas = user?.roles?.includes('coleta') || false
  if (!coletaFaturas) {
    finalItems = finalItems.filter(item => !item.coleta)
  }

  const sentinela = user?.roles?.includes('sentinela') || false
  if (!sentinela) {
    finalItems = finalItems.filter(item => !item.sentinela)
  }

  const gd = user?.roles?.includes('gd') || false
  if (!gd) {
    finalItems = finalItems.filter(item => !item.gd)
  }

  const arquivos = user?.roles?.includes('arquivos') || false
  if (!arquivos) {
    finalItems = finalItems.filter(item => !item.arquivos)
  }

  const habilitarTesteFeature = user?.habilitar_teste_feature || false
  if (habilitarTesteFeature) {
    return finalItems
  }
  return finalItems.filter(item => !item.test)
}

const getItems = user => {
  const items = [
    {
      icon: <DashboardIcon />,
      text: 'Dashboard',
      path: '/app/dashboard',
      divider: true,
    },
    ...(user?.email && QUERY_DINAMICA_ALLOWED_EMAILS.includes(user.email) ? [
      {
        icon: <QueryDinamicaIcon />,
        text: 'Consultas dinâmicas',
        path: '/app/query_dinamica',
      },
    ] : []),
    {
      icon: <AgentesIcon />,
      text: 'Agentes',
      path: '/app/agentes',
    },
    {
      icon: <PainelEnergiaIcon />,
      text: 'Painel de Energia',
      path: '/app/painel',
    },
    {
      icon: <ContratosIcon />,
      text: 'Contratos de Energia',
      path: '/app/contratos',
    },
    ...(user?.email === 'conrado@electricservice.com.br' ? [
      {
        icon: <AssignmentIcon />,
        text: 'Contratos GD',
        path: '/app/contratos_gd',
      },
    ] : []),
    {
      icon: <FechamentosIcon />,
      text: 'Fechamentos',
      path: '/app/fechamentos',
    },
    {
      icon: <PldIcon />,
      text: 'PLD',
      path: '/app/pld',
    },
    {
      icon: <CotacoesIcon />,
      text: 'Cotações',
      path: '/app/cotacoes',
      divider: true,
    },
    {
      icon: <CurtoPrazoIcon />,
      text: 'Curto Prazo',
      path: '/app/operacoes',
    },
    {
      icon: <LongoPrazoIcon />,
      text: 'Longo Prazo',
      path: '/app/longoprazo',
    },
    {
      icon: <FaturamentoIcon />,
      text: 'Faturamento',
      path: '/app/faturamento',
      divider: true,
    },
    {
      icon: <PedagioIcon />,
      text: 'Faturas de uso do sistema',
      path: '/app/pedagio',
    },
    {
      icon: <RelatorioIcon />,
      text: 'Relatórios',
      path: '/app/relatorios',
    },
    ...(eGridElectric
      ? [
          {
            icon: <EcoIcon />,
            text: 'Sustentabilidade',
            path: '/app/sustentabilidade',
            test: true,
          },
        ]
      : []),
    {
      icon: <ConsolidadoIcon />,
      text: 'Relatórios consolidados',
      path: '/app/consolidados',
      divider: true,
    },
    {
      icon: <ConfiguracoesIcon />,
      text: 'Configurações',
      path: '/app/configuracoes',
    },
    {
      icon: <PerfilIcon />,
      text: 'Minha conta',
      path: '/app/conta/perfil',
    },
    ...(eGridV1Chamados
      ? [{ icon: <TicketIcon />, text: 'Chamados', path: '/app/tickets' }]
      : []),
    {
      icon: <ArquivosIvon />,
      text: 'Arquivos',
      path: '/app/arquivos',
    },
    {
      icon: <LogoutIcon />,
      text: 'Sair',
      path: '/session/destroy',
      divider: true,
    },
  ]

  const habilitarTesteFeature = user?.habilitar_teste_feature || false
  if (habilitarTesteFeature) {
    return items
  }
  return items.filter(item => !item.test)
}

export { getClientItems, getItems }
